/**
 * Maps a raw device + surrounding view context into the flat data object
 * consumed by the Device Inventory schema (`x-props` bindings resolve keys
 * from this object via `data.<key>`).
 */
export const deviceInventoryAdapter = ({
  device,
  userConfig,
  selectedLanguage,
  trans,
  timezone,
  connectionStatus,
  loginUserTimeformat,
  deviceStatus,
}) => ({
  device,
  userConfig,
  selectedLanguage,
  trans,
  timezone,
  connectionStatus,
  lastConnectTime: device?.lastconnecttime,
  lastDisconnectTime: device?.lastdisconnecttime,
  loginUserTimeformat,
  deviceStatus,
});
